import { MediaType, MediaTypes } from './reports.internal';

type Integer = number;
type Fraction = number;

export interface IQueueKpi {
    readonly queueId: string,
    sla: Integer,
    abandonThreshold: Integer;
}

export interface IQueueKpiThresholds {
    slaThreshold: Fraction | null;
    maxLwtSeconds: Integer | null;
    averageWaitTimeSeconds: Integer | null;
    maxConversationsWaiting: Integer | null;
}

export interface ITeamKpiThresholds {
    averageHandlingTimeSeconds: { [key in MediaType]: Integer | null };
    handledRatio: { [key in MediaType]: Fraction | null };
}

export interface IChannelKpiThresholds {
    messageConsumptionLimit: number | null;
}

export const defaultQueueKpi: Readonly<IQueueKpi> = {
    queueId: '',
    sla: 0,
    abandonThreshold: 0,
};

export const defaultIQueueKpiThresholds: Readonly<IQueueKpiThresholds> = {
    slaThreshold: null,
    maxLwtSeconds: null,
    averageWaitTimeSeconds: null,
    maxConversationsWaiting: null,
};

export const defaultITeamKpiThresholds: Readonly<ITeamKpiThresholds> = {
    averageHandlingTimeSeconds: MediaTypes.reduce((coll, media) => ({ ...coll, [media]: null }), {} as ITeamKpiThresholds['averageHandlingTimeSeconds']),
    handledRatio: MediaTypes.reduce((coll, media) => ({ ...coll, [media]: null }), {} as ITeamKpiThresholds['handledRatio']),
};

export const defaultIChannelKpiThresholds: Readonly<IChannelKpiThresholds> = {
    messageConsumptionLimit: null,
};